import React from 'react';
import {
  Card,
  CardContent,
  Box,
  Typography,
  Avatar,
  IconButton,
  Chip,
  makeStyles,
  Divider,
  Tooltip
} from '@material-ui/core';
import numeral from 'numeral';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import { useSelector } from 'react-redux';
const useStyles = makeStyles(theme => ({
  item: {
    position: 'relative'
  },
  prodCatContainer: {
    position: 'absolute',
    top: 0,
    right: 0
  },

  avatar: {
    marginRight: theme.spacing(2)
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    background: '#fff',
    zIndex: 100
  },
  table: {
    position: 'relative'
  },
  image: {
    height: '5em',
    width: '5em'
  },
  spacing: {
    gap: theme.spacing(2)
  },
  otherDetails: {
    display: 'block',
    marginRight: theme.spacing(1)
  },
  subLinks: {
    marginTop: '0.5em',
    display: 'flex',
    gap: '0.5em'
  }
}));
const ProdCard = ({
  item,
  index,
  openProdDetails,
  handleProdSelect,
  itemRef,
  onKeyDown,
  prices = [1, 2, 3, 4, 5, 6],
  query = '',
  handleClose
}) => {
  const classes = useStyles();

  const { ixImage } = useSelector(state => state.auth);
  const { inv, frontEnd } = useSelector(({ bizMeta }) => bizMeta);

  const { SN, SN2 } = inv;

  return (
    <Card
      ref={itemRef}
      onKeyDown={onKeyDown}
      className={classes.item}
      elevation={4} // stronger shadow
      style={{
        cursor: 'pointer',
        position: 'relative',
        padding: 6,

        backgroundColor: 'rgba(25, 118, 210, 0.08)', // soft primary tint
        border: '1px solid rgba(25, 118, 210, 0.4)' // clear edge
      }}
      onClick={() => handleClose()}
    >
      <Box
        position="absolute"
        left={0}
        top={0}
        bottom={0}
        width="4px"
        bgcolor="primary.main"
      />
      <CardContent style={{ padding: 8 }}>
        <Box display="flex" alignItems="flex-start" gridGap="10px">
          {/* SMALL IMAGE */}
          <Avatar
            variant="rounded"
            className={classes.image}
            style={{ height: '5em', width: '5em' }}
            src={`/api/images/${ixImage}/prod/${item?.ixProd}/active_prod_avatar.jpg`}
          >
            <ImageOutlinedIcon fontSize="small" />
          </Avatar>

          {/* CONTENT */}
          <Box flex={1}>
            {/* TITLE */}
            <Typography
              variant="body2"
              style={{ fontWeight: 800 }}
              color="textPrimary"
            >
              {item.sProd}
            </Typography>

            {/* META LINE */}
            <Typography variant="caption" color="textSecondary">
              {item.sProdCat} • {item.sCatSub} • {item.ProdCd}
            </Typography>

            {/* SN (compact) */}
            {((Boolean(item?.reqSN) && Boolean(item?.SN)) ||
              (Boolean(item?.reqSN2) && Boolean(item?.SN2))) && (
              <Box display="flex" gridGap="8px" mt={0.5}>
                {item?.reqSN && item?.SN && (
                  <Typography variant="caption">
                    {SN?.label ?? 'SN'}: {item.SN !== 0 ? item.SN : ''}
                  </Typography>
                )}

                {item?.reqSN2 && item?.SN2 && (
                  <Typography variant="caption">
                    {SN2?.label ?? 'SN2'}: {item.SN2 !== 0 ? item.SN2 : ''}
                  </Typography>
                )}
              </Box>
            )}

            {/* SMALL TAG ROW */}
            <Box display="flex" flexWrap="wrap" gridGap="6px" mt={0.5}>
              {item.unit && (
                <Chip size="small" color="primary" label={item.unit} />
              )}

              {(item?.qtySC ?? 0) > 0 && (
                <Chip
                  size="small"
                  color="primary"
                  label={`${item.unitSC}(${item.qtySC})`}
                />
              )}

              {(item?.qtyCS ?? 0) > 0 && (
                <Chip
                  size="small"
                  color="primary"
                  label={`${item.unitCS}(${item.qtyCS})`}
                />
              )}

              {[1, 2, 3, 4, 5].map(n =>
                item[`ixProdSubLink${n}`] ? (
                  <Chip
                    key={n}
                    size="small"
                    color="primary"
                    label={item[`sProdSubLink${n}`]}
                  />
                ) : null
              )}
            </Box>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default ProdCard;
